exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2-gJB-ayu1tL_Y{width:550px}._2mpSJe9AWtzrmg{color:#172b4d;font-size:20px;font-weight:600;letter-spacing:-.008em;line-height:24px;margin-top:28px;background-color:#0079bf;color:#fff;border-radius:3px;width:100%;height:48px;text-align:center;margin-top:0}._2mpSJe9AWtzrmg ._2Q-xd-QIZuMhd4{mix-blend-mode:hard-light}", ""]);

// exports
exports.locals = {
	"container": "_2-gJB-ayu1tL_Y",
	"submitButton": "_2mpSJe9AWtzrmg",
	"spinner": "_2Q-xd-QIZuMhd4"
};